import { getHeader } from "config";
import { hiveInstance } from "config";

/**
 * To get token after number verification
 */
export const loginWithFirebaseAuthToken = (token) => {
  return hiveInstance.post(`/auth/mobile/token`, { token });
};

/**
 * To verify if Phone Number exists in DB and is a Chronos user (admin)
 */
export const verifyPhoneNumberForOTP = (phone_number) => {
  return hiveInstance.post(`/auth/mobile/verify`, { phone_number });
};

export const refreshToken = () => hiveInstance.get("/auth/token", getHeader());
